export const routes = {
    home:"/",

    register:"/sign-up",

    login:"/login",

    verifyOtp:"/verify-otp",

    forgotPasswordEmail:"/forgot-password/email",
    resetPassword:"/reset-password",

    addNpaProperties:"/npa-properties/add",
    editNpaProperties:"/npa-properties/edit/:id",
    viewNpaProperties:"/npa-properties/property-details/:id",

    npaInquiries:"/npa-inquiries",
   

    users:"/users",

    
}